var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('div',{staticClass:"custom_logo",style:({ backgroundImage: 'url(' + _vm.src + ')' })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }